module.exports = __webpack_public_path__ + "img/thumb_code.00232ace.jpg";